import React, { useState } from 'react';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Checkbox } from '../../ui/checkbox';
import { Button } from '../../ui/button';

export const ConfirmPanel = ({ preview, expired, running, stale, error, onExecute }) => {
  const [name, setName] = useState('');
  const [reason, setReason] = useState('');
  const [ack, setAck] = useState(false);
  const ready = name.trim() === (preview.tenant_name || '').trim() && reason.trim() && ack && !expired && !running && !stale;

  return (
    <div className="space-y-4 rounded-lg border-2 border-red-300 bg-red-50/40 p-5" data-testid="reset-confirm-panel">
      <p className="text-sm font-semibold text-red-700">
        This clears {preview.reserved_to_clear} reserved units on {preview.stock_rows_affected} stock rows and sets {preview.request_lines_baselined} request
        lines to hold 0. On hand, allocated, quarantined, value and history do not change.
      </p>
      <label className="block text-sm">Type the company name exactly: <span className="font-mono">{preview.tenant_name}</span>
        <Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1" data-testid="reset-confirm-name-input" />
      </label>
      <label className="block text-sm">Reason (saved in the audit)
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} className="mt-1" data-testid="reset-reason-input" />
      </label>
      <label className="flex items-start gap-2 text-sm">
        <Checkbox checked={ack} onCheckedChange={(v) => setAck(!!v)} data-testid="reset-ack-checkbox" />
        I have reviewed this preview and confirm the reset of this company's Reserved quantities. It can run only once.
      </label>
      <Button variant="destructive" disabled={!ready} onClick={() => onExecute({ name, reason })} data-testid="reset-execute-button">
        {running ? 'Running reset…' : 'Execute reset'}
      </Button>
      {error && <p className="text-sm font-semibold text-red-700" data-testid="reset-execute-error">{error} Use “Fresh preview” at the top.</p>}
      {expired && <p className="text-sm text-red-700" data-testid="reset-preview-expired">The preview expired. Refresh it before running.</p>}
    </div>
  );
};
